import { useDispatch, useSelector } from 'react-redux';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import RadioButtonsGroup from '../../RadioButtonsGroup';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import styles from './inquiriesReceived.module.scss';
import { INQUIRY_CATEGORIES } from '../../constants';
import { setInquiriesReceived } from '@/store/slices/components/dashboard/DashboardSlice';
import InquiriesReceivedRow from './InquiriesReceivedRow';
import PerformanceCard from '../PerformanceCard';
import ToolTip from '@/components/ToolTip/ToolTip';
import { useTrackPerformanceTabCard } from '../../customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '../../constants/track';

export default function InquiriesReceivedContent() {
  const dispatch = useDispatch();
  const { inquiriesReceived } = useSelector((state) => state.DashboardSlice);
  const track = useTrackPerformanceTabCard();
  const { value, options, selectedOption, variation, percentage_status, icon } =
    inquiriesReceived;
  const selectedList = options[selectedOption].list;
  const selectedOthers = options[selectedOption].others;

  const othersCount = selectedOthers.reduce((acc, curr) => acc + curr.count, 0);
  const othersPercentage = selectedOthers.reduce(
    (acc, curr) => acc + curr.percentage,
    0
  );
  const handleClickRadio = (item) => {
    dispatch(setInquiriesReceived({ key: 'selectedOption', value: item.id }));
    track.inquiriesReceived(TRACK_ELEMENT.RADIO_BUTTON_OPTION);
  };

  const getTooltipContent = () => {
    const maxVisible = 12;
    const visible = selectedOthers.slice(0, maxVisible);
    const remaining = selectedOthers.length - maxVisible;

    return (
      <>
        {visible.map((event) => (
          <Text key={event.id}>{`${event.name}: ${event.count}`}</Text>
        ))}
        {remaining > 0 && (
          <Text>{`${Trans(translations, 'CountMore', remaining)}...`}</Text>
        )}
      </>
    );
  };

  const hasLabel = (inquiry) =>
    Boolean(inquiry.with_operation_label || inquiry.with_origin_label);

  const allowedOptions = [
    { id: INQUIRY_CATEGORIES.SOURCE, text: Trans(translations, 'Source') },
    {
      id: INQUIRY_CATEGORIES.OPERATION,
      text: Trans(translations, 'Operation'),
    },
  ];

  return (
    <>
      <PerformanceCard.Summary
        value={value}
        percentageStatus={percentage_status}
        tendency={variation}
        icon={icon}
      >
        <RadioButtonsGroup
          allowedOptions={allowedOptions}
          selectedOption={selectedOption}
          onClickRadio={handleClickRadio}
        />
      </PerformanceCard.Summary>
      <PerformanceCard.Content>
        <Box className={styles.rowsWrapper}>
          {selectedList.map((inquiry) => (
            <InquiriesReceivedRow
              key={inquiry.name}
              name={inquiry.name}
              percentage={inquiry.percentage}
              count={inquiry.count}
              withLabel={hasLabel(inquiry)}
            />
          ))}

          {selectedOthers.length > 0 && (
            <ToolTip title={getTooltipContent()}>
              <InquiriesReceivedRow
                name={Trans(translations, 'Others')}
                percentage={othersPercentage}
                count={othersCount}
              />
            </ToolTip>
          )}
        </Box>
      </PerformanceCard.Content>
    </>
  );
}
